//@ts-nocheck
import React from "react";
import { ErrorPage } from "./_new_/components/error-page/ErrorPage";
import { LascodalErrorPage } from "./_new_/components/lascodal/LascodalErrorPage";

class ErrorBoundary extends React.Component<
  {
    processError?: (error: any, errorInfo: any) => void;
    children: React.ReactNode;
    errorComponent?: React.ReactNode;
    ignore?: boolean;
    useLascodaErrorPage?: boolean;
  },
  {
    hasError: boolean;
  }
> {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    if (!this.props.ignore && this.props.processError) {
      console.log({ error, errorInfo });
      this.props.processError(error, errorInfo);
    }
  }
  render() {
    // Check if the error is thrown
    if (!this.props.ignore && this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.errorComponent ? (
        this.props.errorComponent
      ) : this.props.useLascodaErrorPage ? (
        <LascodalErrorPage />
      ) : (
        <ErrorPage />
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default ErrorBoundary;
